module.exports = __webpack_public_path__ + "static/media/9.c00205a0.jpeg";